<template>
  <div class="footer-container">
    <div class="footer_box">
      <div class="footer_box-icon">
        <img src="../../assets/icon-wb.png"/>
        <img src="../../assets/icon-wx.png"/>
        <img src="../../assets/icon-f.png"/>
        <img src="../../assets/icon-xn.png"/>
      </div>
      <p>北京版全家科技发展有限公司   |  北京朝阳区华腾世纪总部公园D座8层</p>
      <p>客服电话 400-878-5066  |  合作邮箱 banquanja@bqj.com.cn</p>
      <p>
        <router-link :to="{path:'/agreement', query:{type:'3'}}" target="_blank">隐私协议</router-link>   |  
        <router-link :to="{path:'/agreement', query:{type:'1'}}" target="_blank">版权方用户协议</router-link>   |  
        <router-link :to="{path:'/agreement', query:{type:'2'}}" target="_blank">运营方用户协议</router-link>   |  
        Copyright © www.bqj.cn, All Rights Reserved</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      html: ''
    }
  },
  created() {},
  methods: {

  }
}
</script>
<style lang="stylus" scoped>
    .footer-container{
      width:100%;
      height 312px
      background: #000000;
      padding-top 90px
      .footer_box{
        width 1334px
        height 180px
        margin 0 auto
        border-top 1px solid #A2A2A2
        padding-top 15px
        position relative
        p,a{
          font-size: 14px;
          color: #FFFFFF;
          line-height 30px
          height 30px
        }
        .footer_box-icon{
          position absolute
          width 190px
          height 29px
          display flex
          align-items center
          justify-content space-between
          top 30px
          right 0
          img{
            height 29px
            width 29px
            cursor pointer
          }
        }
      }
      
    }
</style>



// WEBPACK FOOTER //
// src/layout/footer/footer.vue